import { IOutboxMessage } from "./outbox-message";
import { createOutboxMessage } from "./outbox-message-factory";
import { OutboxMessageTitles } from "./outbox-message-titles";

export interface ICustomerDetailsSectionButtonClickMessage extends IOutboxMessage {
  readonly title: OutboxMessageTitles.CustomerDetailsSectionButtonClick;
  readonly data: { buttonId: string };
}

export function createCustomerDetailsSectionButtonClickMessage(
  pluginId: string,
  buttonId: string
): ICustomerDetailsSectionButtonClickMessage {
  return createOutboxMessage<ICustomerDetailsSectionButtonClickMessage>(
    OutboxMessageTitles.CustomerDetailsSectionButtonClick,
    pluginId,
    { buttonId }
  );
}
